// src/components/common/audio-player/session/useAudioSessionControls.ts

"use client";
import { useCallback, useSyncExternalStore } from "react";
import { audioSession } from "./AudioSession";

export function useAudioSessionControls(
  audioRef: React.RefObject<HTMLAudioElement | null>,
  ownerId: string
) {
  useSyncExternalStore(
    audioSession.subscribe.bind(audioSession),
    () => 0
  );

  const claim = useCallback(() => {
    const el = audioRef.current;
    if (el) audioSession.attach(el, ownerId);
  }, [audioRef, ownerId]);

  const toggle = useCallback(() => { claim(); audioSession.toggle(); }, [claim]);
  const play   = useCallback(() => { claim(); audioSession.play(); }, [claim]);
  const pause  = useCallback(() => { claim(); audioSession.pause(); }, [claim]);
  const seek   = useCallback((t: number) => { claim(); audioSession.seek(t); }, [claim]);
  const setRate= useCallback((r: number) => { claim(); audioSession.setRate(r); }, [claim]);

  return { toggle, play, pause, seek, setRate };
}